module.exports = __webpack_public_path__ + "static/media/door_with_sign.51998538.jpg";